import { useMutation, useQueryClient } from "@tanstack/react-query";
import { axios } from "./axios";
import { useAuth } from "../context/AuthContext";
import { env } from "../utils/env";

type Params = {
  profileId: number;
  newStatusId: number;
  comment?: string;
};

export const useUpdateProfileStatus = () => {
  const { authHeader } = useAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ profileId, newStatusId, comment }: Params) => {
      const payload = {
        status: newStatusId,
        comment: comment ?? "",
      };

      return axios.patch(
        `${env.verifyServiceUrl}individual/profile/${profileId}/status/`,
        payload,
        {
          headers: {
            Authorization: authHeader,
          },
        }
      );
    },
    onSuccess: async (_data, vars) => {
      await queryClient.invalidateQueries({
        queryKey: ["profile", vars.profileId],
      });
    },
  });
};
